import {DepositCmaHelper} from "./deposit-cma/DepositCmaHelper";

export default angular.module("tfApp.helpers", [])
                      .service(DepositCmaHelper.id, DepositCmaHelper)
                      .name;
